// ----------------------------
// Created by Bulletproof Games
//            2016
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Stake Selection Container
//
// Popup for players to select stake

dsStakeSelectionPopup = {};
dsStakeSelectionPopup.popups = [];

////////////////////////////////////
dsStakeSelectionPopup.create = function () {
  var object = new PIXI.Container();
  dsStakeSelectionPopup.container = object;

  // Get all objects on the autoplay dialog
  object.dialog = {};
  object.dialog.callbacks = {};

  object.openDialog = dsStakeSelectionPopup.openDialog;
  object.selectLayout = dsStakeSelectionPopup.selectLayout;
  object.updateLayout = dsStakeSelectionPopup.updateLayout;
  object.forceClose = dsStakeSelectionPopup.forceClose;

  object.checkLuckyBet = dsStakeSelectionPopup.checkLuckyBet;

  dsStakeSelectionPopup.luckyBetPlatformEnabled = false;
  dsStakeSelectionPopup.luckyBetPlatformVisible = false;

  dsStakeSelectionPopup.goldenBetStakes = undefined;

  // Hide by default
  object.visible = false;
  object.isActive = false;

  dsStakeSelectionPopup.popups.push(object);

  const self = this;
  messageBus.subscribe('spinner:GameConfigEvent', dsStakeSelectionPopup.createButtons.bind(dsStakeSelectionPopup));
  messageBus.subscribe('game:modal', dsStakeSelectionPopup.onModal.bind(dsStakeSelectionPopup));

  return object;
};

////////////////////////////////////
dsStakeSelectionPopup.destroy = function (popup) {
  var index = dsStakeSelectionPopup.popups.indexOf(popup);
  if (index === -1) {
    console.log('Could not destroy stake selection popup as it could not be found');
    return;
  }

  dsStakeSelectionPopup.popups.splice(index, 1);
};

////////////////////////////////////
dsStakeSelectionPopup.initialise = function (json, object) {
  object.dialog.buttonGlow = resourceManager.get('buttonContainer:buttonBar:stakeButton:glow');
  object.dialog.buttonGlow.visible = false;

  // Clickable background behind panel
  object.dialog.touchCancel = resourceManager.createObject('colourBox', 'touchCancel', json.FQN, {
    width: 1000,
    height: 1000,
    x: -1000,
    y: -1000,
    scale: 4,
    alpha: 0.7,
    colour: 0x000000,
  });
  object.dialog.touchCancel.visible = false;
  object.dialog.touchCancel.interactive = false;
  object.dialog.touchCancel.mousedown = object.dialog.touchCancel.touchstart = dsStakeSelectionPopup.onCancel;

  object.dialog.buttons = [];
  object.dialog.buttonsText = [];
  //    object.dialog.buttonsDescription = [];

  // Create background / title - set interactive to prevent clickthrough
  object.dialog.background = resourceManager.createObject('sprite', 'background', json.FQN, {
    fileName: json.backgroundFile,
  });
  object.dialog.background.interactive = true;

  var maxWidth = checkForDefined(json.maxWidth) ? json.maxWidth : object.dialog.background.width;
  const titleTextContainer = resourceManager.createObject('container', 'titleContainer', json.FQN);
  titleTextContainer.scale.set(0.5);
  resourceManager.createObject('text', 'title', json.FQN + ':titleContainer', {
    text: '',
    translationPhrase: json.translationPhrase,
    fontDefinition: 'popupTitle',
    x: (maxWidth / 2) * 2,
    y: 40 * 2,
    maxWidth: 600 * 2,
  });

  object.dialog.seperator = resourceManager.createObject('sprite', 'seperator', json.FQN + ':background', {
    fileName: 'Desktop_UI_SystemSettings/Pop_Up_Panel_Line.png',
    x: 100,
    y: 60,
  });

  object.dialog.JSONbuttonFQN = json.FQN;
  object.dialog.JSONbuttonText = json.buttonText;
  object.dialog.JSONbuttonFile = json.buttonFile;
  object.dialog.JSONbuttonFont = json.buttonDescriptionDefinition;
  object.dialog.JSONMaxWidth = maxWidth;

  // const maxNumStakeButtons = 18;

  // // Create all buttons we will need
  // for (var i = 0; i < maxNumStakeButtons; i++) {
  //     var button = resourceManager.createObject("sprite", "button"+i, json.FQN + ":background", { fileName: json.buttonFile } );
  //     //maxWidth = (checkForDefined(json.maxButtonWidth) ? json.maxButtonWidth : button.width);

  //     button.stakeIndex = i;
  //     button.interactive = true;
  //     button.mousedown = button.touchstart = dsStakeSelectionPopup.onStakeButtonPressed;
  //     button.anchor.set(0.5);
  //     object.dialog.buttons.push(button);

  //     var buttonText = resourceManager.createObject("text", "buttonText"+i, json.FQN + ":background" + ":button"+i, { text: json.buttonText, maxWidth: 70, maintainAspectRatio: false, fontDefinition: "popupBetSettingsMoney", x:-4,y:-3 } );
  //     object.dialog.buttonsText.push(buttonText);

  //     var buttonDescription = resourceManager.createObject("text", "buttonDescription"+i, json.FQN + ":background" + ":button"+i, { text: json.buttonText, maxWidth: maxWidth, fontDefinition: json.buttonDescriptionDefinition, x:0, y:0 } );
  //     object.dialog.buttonsDescription.push(buttonDescription);

  // }
  //Creating other interface bits

  /////////////////////////////////////
  if (gdk.getPlatformAllowsUpstake()) {
    object.dialog.luckyBetOn = resourceManager.createObject('sprite', 'luckyBetOn', json.FQN + ':background', {
      fileName: 'Golden_Bet<&social&>/goldenBet/golden_bet_00019.png',
      x: 360,
      y: 130,
      anchor: 0.5,
      scale: 0.7,
    });
    object.dialog.luckyBetOn.interactive = false;
    object.dialog.luckyBetOn.mousedown = object.dialog.luckyBetOn.touchstart = dsStakeSelectionPopup.luckyBetOnPressed;
    object.dialog.luckyBetOn.visible = false;

    // object.dialog.tickOn = resourceManager.createObject('sprite', 'luckyBetOff', json.FQN + ':background:luckyBetOn', {
    //   fileName: 'Golden_Bet/Golden_Bet_ON.png',
    //   x: 50,
    //   y: 12,
    //   anchor: 0.5,
    // });

    /////////////////////////////////////
    object.dialog.luckyBetOff = resourceManager.createObject('sprite', 'luckyBetOff', json.FQN + ':background', {
      fileName: 'Golden_Bet<&social&>/goldenBet/golden_bet_00000.png',
      x: 360,
      y: 130,
      anchor: 0.5,
      scale: 0.7,
    });
    object.dialog.luckyBetOff.interactive = true;
    object.dialog.luckyBetOff.mousedown = object.dialog.luckyBetOff.touchstart =
      dsStakeSelectionPopup.luckyBetOffPressed;
    object.dialog.luckyBetOff.visible = true;

    // object.dialog.tickOff = resourceManager.createObject(
    //   'sprite',
    //   'luckyBetOff',
    //   json.FQN + ':background:luckyBetOff',
    //   {
    //     fileName: 'Golden_Bet/Golden_Bet_OFF.png',
    //     x: 50,
    //     y: 12,
    //     anchor: 0.5,
    //   }
    // );
  }

  /////////////////////////////////////
  object.dialog.continueButton = resourceManager.createObject('sprite', 'continueButton', json.FQN + ':background', {
    fileName: 'Desktop_UI_AutoplaySettings/Desktop_Start_Button.png',
    x: 360,
    y: 440,
    anchor: 0.5,
    alpha: 1,
  });
  object.dialog.continueButtonTextContainer = resourceManager.createObject(
    'container',
    'continueButtonTextContainer',
    json.FQN + ':background' + ':continueButton'
  );
  object.dialog.continueButtonTextContainer.scale.set(0.5);
  object.dialog.continueButton.text = resourceManager.createObject(
    'text',
    'continueButtonText',
    json.FQN + ':background' + ':continueButton' + ':continueButtonTextContainer',
    {
      translationPhrase: 't_continue',
      fontDefinition: 'popupBetSettingsContinue',
      maxWidth: 440,
      x: -3 * 2,
      y: -3 * 2,
    }
  );

  object.dialog.continueButton.interactive = true;
  object.dialog.continueButton.mousedown = object.dialog.continueButton.touchstart =
    dsStakeSelectionPopup.onContinuePressed;

  ////////////////////////////////////
  var closeButton = resourceManager.createObject('sprite', 'closeButton', json.FQN + ':background', {
    fileName: 'Desktop_UI_SystemSettings/Desktop_Close_Button.png',
    x: 683,
    y: 28,
    anchor: 0.5,
  });

  closeButton.interactive = true;
  closeButton.mousedown = closeButton.touchstart = dsStakeSelectionPopup.onCancel;
};

////////////////////////////////////
dsStakeSelectionPopup.onModal = function (msg) {
  // Pressing max bet or lucky bet takes us out of modal but we are still visible, keep modal
  // This means the dialog will be still open allowing the player to spin behind the stake dialog - go back to modal if
  // the dialog is still open
  if (dsStakeSelectionPopup.isActive && msg.reason === undefined) {
    messageBus.post('game:modal', { reason: 'Stake dialog open' });
  }
};

////////////////////////////////////
dsStakeSelectionPopup.createButtons = function (configEvent) {
  let stakeController = resourceManager.getController('stakeController');
  const maxNumStakeButtons = stakeController.Stakes.length;

  dsStakeSelectionPopup.goldenBetStakes = configEvent.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;

  dsStakeSelectionPopup.luckyBetPlatformEnabled = configEvent.data.uiElements.btnUpstake.enabled;
  dsStakeSelectionPopup.luckyBetPlatformVisible = configEvent.data.uiElements.btnUpstake.visible;

  // Create all buttons we will need
  for (var i = 0; i < maxNumStakeButtons; i++) {
    var button = resourceManager.createObject(
      'sprite',
      'button' + i,
      dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ':background',
      { fileName: dsStakeSelectionPopup.container.dialog.JSONbuttonFile }
    );
    //maxWidth = (checkForDefined(json.maxButtonWidth) ? json.maxButtonWidth : button.width);

    button.stakeIndex = i;
    button.stake = stakeController.Stakes[i];
    button.interactive = true;
    button.mousedown = button.touchstart = dsStakeSelectionPopup.onStakeButtonPressed;
    button.anchor.set(0.5);
    dsStakeSelectionPopup.container.dialog.buttons.push(button);

    var scaledContainer = resourceManager.createObject(
      'container',
      'buttonTextContainer' + i,
      dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ':background' + ':button' + i
    );
    scaledContainer.scale.set(0.5);

    var buttonText = resourceManager.createObject(
      'text',
      'buttonText' + i,
      dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ':background' + ':button' + i + ':buttonTextContainer' + i,
      {
        text: dsStakeSelectionPopup.container.dialog.JSONbuttonText,
        maxWidth: 90 * 2,
        maintainAspectRatio: false,
        fontDefinition: 'popupBetSettingsMoney',
        x: -4 * 2,
        y: -3 * 2,
      }
    );
    dsStakeSelectionPopup.container.dialog.buttonsText.push(buttonText);

    //        var buttonDescription = resourceManager.createObject("text", "buttonDescription"+i, dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ":background" + ":button"+i, { text: dsStakeSelectionPopup.container.dialog.JSONbuttonText, maxWidth: dsStakeSelectionPopup.container.dialog.JSONMaxWidth, fontDefinition: dsStakeSelectionPopup.container.dialog.JSONbuttonFont, x:0, y:0 } );
    //        dsStakeSelectionPopup.container.dialog.buttonsDescription.push(buttonDescription);
  }
};

////////////////////////////////////
dsStakeSelectionPopup.onCancel = function () {
  dsStakeSelectionPopup.isActive = false;

  dsStakeSelectionPopup.container.dialog.chosenStake = undefined;
  dsStakeSelectionPopup.container.dialog.continueButton.interactive = false;
  soundManager.play('stakeCancelled');
  dsStakeSelectionPopup.forceClose();
  dsStakeSelectionPopup.container.dialog.callbacks.cancelled();
};

////////////////////////////////////
dsStakeSelectionPopup.luckyBetOffPressed = function () {
  let popup = dsStakeSelectionPopup.container;

  popup.dialog.luckyBetOn.interactive = true;
  popup.dialog.luckyBetOff.interactive = false;

  popup.dialog.luckyBetOn.visible = true;
  popup.dialog.luckyBetOff.visible = false;

  let encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');
  encoreButtonLB.onPressedCallback();

  var stakeController = resourceManager.getController('stakeController');
  popup.selectLayout(stakeController.Stakes);

  popup.dialog.buttonsText[stakeController.SelectedStakeIndex].style.fill = 0x62e702;

  dsStakeSelectionPopup.checkValidStakes(true);
};

////////////////////////////////////
dsStakeSelectionPopup.luckyBetOnPressed = function () {
  let popup = dsStakeSelectionPopup.container;

  popup.dialog.luckyBetOn.interactive = false;
  popup.dialog.luckyBetOff.interactive = true;

  popup.dialog.luckyBetOn.visible = false;
  popup.dialog.luckyBetOff.visible = true;

  let encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');
  encoreButtonLB.onPressedCallback();

  var stakeController = resourceManager.getController('stakeController');
  popup.selectLayout(stakeController.Stakes);

  popup.dialog.buttonsText[stakeController.SelectedStakeIndex].style.fill = 0x62e702;

  dsStakeSelectionPopup.checkValidStakes(false);
};

////////////////////////////////////
dsStakeSelectionPopup.onStakeButtonPressed = function () {
  var popup = this.parent.parent;

  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    popup.dialog.buttonsText[i].style.fill = 0xffffff;
  }

  popup.dialog.continueButton.alpha = 1;
  popup.dialog.continueButton.text.style.fill = 0x62e702;

  popup.dialog.buttonsText[this.stakeIndex].style.fill = 0x62e702;
  popup.dialog.chosenStake = this.stakeIndex;
  popup.dialog.continueButton.interactive = true;

  // Now we have left dialog, inform game of stake selected
  popup.dialog.callbacks.stakeSelected(this.stakeIndex);
  resourceManager.get('meterContainer:winnings').visible = false;
  gameData.winningsMeter.set(0);

  soundManager.play('stakeSelected');

  if (gdk.getPlatformAllowsUpstake()) dsStakeSelectionPopup.checkLuckyBet();
};

////////////////////////////////////
dsStakeSelectionPopup.onContinuePressed = function () {
  dsStakeSelectionPopup.isActive = false;
  var popup = dsStakeSelectionPopup.container;

  soundManager.play('buttonPressed');

  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    popup.dialog.buttons[i].interactive = false;
  }

  timerManager.addTimer(100, dsStakeSelectionPopup.fadeOutDialog, dsStakeSelectionPopup.fadeOutDialogComplete, popup);
  popup.dialog.selectedStakeIndex = popup.dialog.chosenStake;
};

////////////////////////////////////
dsStakeSelectionPopup.selectLayout = function (stakes) {
  this.dialog.numItems = stakes.length;
  this.dialog.stakes = stakes;

  if (this.dialog.numItems === 0) {
    console.error('Not stakes passed into stake selection popup');
    return;
  }

  this.dialog.currentHeight = Math.floor((this.dialog.numItems - 1) / 3) + 1;
  this.dialog.currentWidth = this.dialog.numItems < 4 ? this.dialog.numItems : 3;
  if (this.dialog.numItems === 4) {
    this.dialog.currentWidth = 2;
  }

  this.updateLayout();
};

////////////////////////////////////
dsStakeSelectionPopup.updateAllLayouts = function () {
  for (var i = 0; i < dsStakeSelectionPopup.popups.length; i++) {
    dsStakeSelectionPopup.popups[i].updateLayout();
  }
};

////////////////////////////////////
dsStakeSelectionPopup.updateLayout = function () {
  dsStakeSelectionPopup.container.dialog.continueButton.interactive = true;

  if (!dsStakeSelectionPopup.isActive) {
    return;
  }

  var margin = 28 / resourceManager.selectedAssetResolution.scaleFactor;
  var buttonWidth = this.dialog.buttons[0].texture.width * resourceManager.selectedAssetResolution.scaleFactor;
  var fullWidth =
    (this.dialog.background.texture.width - margin * 2) * resourceManager.selectedAssetResolution.scaleFactor;

  // Layout buttons we are going to use
  var currentButtonIndex = 0;
  var itemsRemaining = this.dialog.numItems;
  var layoutString = '';
  var stakeController = resourceManager.getController('stakeController');
  var maxStake =
    stakeController.Stakes[stakeController.Stakes.length - 1] /
    (stakeController.CurrentStake / stakeController.BaseStake);
  var stakes = stakeController.Stakes;

  var xLeft = 80;
  var xRight = 630;
  var yStart = 220;
  var columns = 6;

  var xGap = (-xLeft + xRight) / (columns - 1);
  var yGap = 50;

  var rowCount = 0;
  var colCount = 0;

  for (let i = 0; i < stakes.length; i++) {
    if (rowCount === columns) {
      rowCount = 0;
      colCount++;
    }

    var xPos = xLeft + xGap * rowCount;
    var yPos = yStart + yGap * colCount;

    if (stakes[i]) {
      this.dialog.buttons[i].position.set(xPos, yPos);
      this.dialog.buttons[i].interactive = true;
      this.dialog.buttons[i].alpha = 1;
      this.dialog.buttons[i].exists = true;
    } else {
      this.dialog.buttons[i].position.set(xPos, yPos);
      this.dialog.buttons[i].interactive = false;
      this.dialog.buttons[i].alpha = 0.5;
      this.dialog.buttons[i].exists = false;
    }
    rowCount++;
  }

  //    this.dialog.continueButton.alpha = 0.5;
  //    this.dialog.continueButton.text.style.fill = 0xFFFFFF;

  for (var i = 0; i < this.dialog.currentHeight; i++) {
    var itemsInThisRow = Math.min(this.dialog.currentWidth, itemsRemaining);
    layoutString += itemsInThisRow.toString() + ',';
    var buttonSpace = 15;
    var buttonOffsetX = buttonSpace + buttonWidth;
    var buttonStartX =
      (this.dialog.background.texture.width / 2) * resourceManager.selectedAssetResolution.scaleFactor -
      (itemsInThisRow - 1) * (buttonOffsetX * 0.5);

    for (var j = 0; j < itemsInThisRow; j++) {
      var x = buttonStartX + j * buttonOffsetX;
      var y = ((420 - this.dialog.currentHeight * 156) / (this.dialog.currentHeight + 1)) * (i + 1) + i * 125 + 184;
      var stake = this.dialog.stakes[currentButtonIndex];

      if (!this.dialog.buttons[currentButtonIndex]) {
        return;
      }
      this.dialog.buttons[currentButtonIndex].visible = true; //(stake <= maxStake);
      //this.dialog.buttonsText[currentButtonIndex].position.set(0, -5);
      this.dialog.buttonsText[currentButtonIndex].setText(MeterManager.formatText(stake));
      //            this.dialog.buttonsDescription[currentButtonIndex].setText("");
      this.dialog.buttonsText[currentButtonIndex].anchor.set(0.5);

      if (this.dialog.buttons[currentButtonIndex].stakeIndex === stakeController.SelectedStakeIndex) {
        this.dialog.buttonsText[currentButtonIndex].style.fill = 0x62e702;
      } else {
        this.dialog.buttonsText[currentButtonIndex].style.fill = 0xffffff;
      }

      currentButtonIndex++;
    }
    itemsRemaining -= itemsInThisRow;
  }

  if (gdk.getPlatformAllowsUpstake()) dsStakeSelectionPopup.checkLuckyBet();
};

dsStakeSelectionPopup.checkLuckyBet = function () {
  let popup = dsStakeSelectionPopup.container;
  let luckyBet = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');

  if (luckyBet.getCanPlaceBet()) {
    popup.dialog.luckyBetOff.visible = !luckyBet._flags.showLuckyBetActive;
    popup.dialog.luckyBetOn.visible = luckyBet._flags.showLuckyBetActive;

    popup.dialog.luckyBetOff.interactive = !luckyBet._flags.showLuckyBetActive;
    popup.dialog.luckyBetOn.interactive = luckyBet._flags.showLuckyBetActive;
  } else {
    popup.dialog.luckyBetOff.visible = false;
    popup.dialog.luckyBetOn.visible = false;

    popup.dialog.luckyBetOn.interactive = false;
    popup.dialog.luckyBetOff.interactive = false;
  }
};

dsStakeSelectionPopup.checkValidStakes = function (show) {
  if (show) {
    dsStakeSelectionPopup.container.dialog.buttons.forEach((button) => {
      let stake = button.stake / 50;
      let included = dsStakeSelectionPopup.goldenBetStakes.includes(stake);
      if (!included) {
        button.visible = false;
      }
    });
  } else {
    dsStakeSelectionPopup.container.dialog.buttons.forEach((button) => {
      button.visible = true;
    });
  }
};

////////////////////////////////////
dsStakeSelectionPopup.fadeInDialog = function (progress, object) {
  object.alpha = progress;
};

////////////////////////////////////
dsStakeSelectionPopup.fadeInDialogCompete = function (object) {
  // Set all buttons to interactive
  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    object.dialog.buttons[i].interactive = true;
  }

  object.dialog.touchCancel.interactive = true;
  object.dialog.touchCancel.visible = true;

  object.alpha = 1;
};

////////////////////////////////////
dsStakeSelectionPopup.fadeOutDialog = function (progress, object) {
  object.alpha = 1 - progress;
};

////////////////////////////////////
dsStakeSelectionPopup.fadeOutDialogComplete = function (object) {
  dsStakeSelectionPopup.forceClose();

  // Now we have left dialog, inform game of stake selected
  object.dialog.callbacks.stakeSelected(object.dialog.selectedStakeIndex);

  object.dialog.touchCancel.interactive = false;
  object.dialog.touchCancel.visible = false;
};

////////////////////////////////////
dsStakeSelectionPopup.forceClose = function () {
  dsStakeSelectionPopup.container.dialog.buttonGlow.visible = false;
  dsStakeSelectionPopup.container.visible = false;
  dsStakeSelectionPopup.container.alpha = 1;
  dsStakeSelectionPopup.isActive = false;
};

////////////////////////////////////
dsStakeSelectionPopup.openDialog = function (stakes, stakeSelectedCallback, cancelledCallback) {
  dsStakeSelectionPopup.isActive = true;

  if (
    checkForUndefined(
      stakeSelectedCallback,
      'stake selected callback was not defined in dsStakeSelectionPopup.openDialog',
      true
    ) ||
    checkForUndefined(cancelledCallback, 'Cancel callback was not defined in dsStakeSelectionPopup.openDialog', true)
  ) {
    return;
  }

  // set correct state of dialog lucky bet button on entry
  let encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');

  if (gdk.getPlatformAllowsUpstake()) {
    this.dialog.luckyBetOn.interactive =
      encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled;
    this.dialog.luckyBetOff.interactive =
      !encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled;

    this.dialog.luckyBetOn.visible =
      encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformVisible;
    this.dialog.luckyBetOff.visible =
      !encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformVisible;
  }

  //  encoreEffect.cancelPopup();
  this.dialog.buttonGlow.visible = true;

  // Fade in dialog
  this.visible = true;
  this.alpha = 0;
  timerManager.addTimer(100, dsStakeSelectionPopup.fadeInDialog, dsStakeSelectionPopup.fadeInDialogCompete, this);

  // Store callbacks
  this.dialog.callbacks.stakeSelected = stakeSelectedCallback;
  this.dialog.callbacks.cancelled = cancelledCallback;

  // Set up layout
  dsStakeSelectionPopup.isActive = true;
  this.selectLayout(stakes);

  dsStakeSelectionPopup.checkValidStakes(encoreButtonLB._flags.showLuckyBetActive && encoreButtonLB.getCanPlaceBet());

  // highlight current stake
  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    if (this.dialog.buttons[i].stakeIndex === stakeController.SelectedStakeIndex) {
      this.dialog.buttonsText[i].style.fill = 0x62e702;

      // set the current stake on entry otherwise it clears down when the dialog is closed with no selection.
      this.dialog.chosenStake = stakeController.SelectedStakeIndex;
    } else {
      this.dialog.buttonsText[i].style.fill = 0xffffff;
    }
  }
};

////////////////////////////////////
dsStakeSelectionPopup.getFileRequired = function (json) {
  return [json.backgroundFile, json.buttonFile, 'Desktop_UI_SystemSettings/Pop_Up_Panel_Line.png'];
};

////////////////////////////////////
Reflex.registerEventHandler('resize', dsStakeSelectionPopup.updateAllLayouts);
resourceManager.registerObjectType(
  'dsStakeSelectionEdited',
  dsStakeSelectionPopup.create,
  dsStakeSelectionPopup.initialise,
  dsStakeSelectionPopup.getFileRequired,
  dsStakeSelectionPopup.destroy
);
